import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Modal, Button } from "react-bootstrap";

const MapContainerModal = ({ show, onHide, address, lat, lng }) => {
    const position = [lat, lng]; // Coordonnées du marqueur

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h4>Position sur la carte </h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ height: "400px", width: "100%" }}>
                    <MapContainer center={position} zoom={13} style={{ height: "100%", width: "100%" }}>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={position}>
                            <Popup>
                                {address || "Aucune adresse spécifiée"}
                            </Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" size="sm" onClick={onHide}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MapContainerModal;